import { useEffect, startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { OnboardingStepName } from "@platform/types/onboarding.types";
import { useOnboarding } from "../../OnboardingContext";
import { useOnboardingStep } from "../../hooks/useOnboardingStep";
import { QuizContainer } from "../../../quiz/components/Quiz/QuizContainer";
import { QuizProvider } from "../../../quiz/QuizContext";
import { quizEventBus } from "../../../quiz/quiz.events";

export function OnboardingQuizContainer({
  stepName,
}: {
  stepName: OnboardingStepName;
}) {
  const navigate = useNavigate();

  const { invitation } = useOnboarding();

  // @todo hardcoded while quiz logic is being rewritten
  const quizId = 1;
  const quizResponseId = 4719;

  const { completeStep } = useOnboardingStep();

  const handleComplete = () => {
    quizEventBus.emitEvent("quiz:completed", {
      quizId: quizId!,
      invitationId: invitation?.id || 0,
    });

    startTransition(() => {
      completeStep(stepName);

      const nextUrl = stepName === "fit" ? "/signup" : "/invite";

      navigate(nextUrl);
    });
  };

  useEffect(() => {
    if (stepName === "fit") {
      handleComplete();
    }
  }, [stepName]);

  return (
    <QuizProvider>
      <QuizContainer
        quizResponseId={quizResponseId}
        onCompleteQuiz={handleComplete}
      />
    </QuizProvider>
  );
}

export default OnboardingQuizContainer;
